(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-group-showcase-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('gb-group-carousel')) return;

    class GbGroupCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.carouselReady === 'true') return;
        this.dataset.carouselReady = 'true';

        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.originalSlides = Array.from(this.querySelectorAll('[data-carousel-slide]:not([data-clone])'));
        this.loopEnabled = this.dataset.loop === 'true' && this.originalSlides.length > 1;
        this.autoplayDesktop = this.dataset.autoplay === 'true';
        this.autoplayMobile = this.dataset.mobileAutoplay === 'true';
        this.autoplaySpeed = Math.max(2000, Number(this.dataset.autoplaySpeed) || 5000);
        this.swipeThreshold = Math.max(12, Number(this.dataset.swipeThreshold) || 24);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktopMedia = window.matchMedia('(min-width: 750px)');
        this.pauseReasons = new Set();
        this.logicalIndex = 0;
        this.scrollFrame = null;
        this.scrollTimer = null;
        this.autoplayTimer = null;
        this.resizeTimer = null;
        this.centerTimer = null;
        this.centerAnimationFrame = null;
        this.touchSnapTimer = null;
        this.touchSnapActive = false;
        this.isCentering = false;
        this.didDrag = false;
        this.didTouchSwipe = false;

        if (!this.track || !this.originalSlides.length) return;

        if (this.loopEnabled) this.createLoopClones();
        this.slides = Array.from(this.track.querySelectorAll('[data-carousel-slide]'));

        this.handleScroll = this.onScroll.bind(this);
        this.handleScrollEnd = this.onScrollSettled.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
        this.handlePointerDown = this.onPointerDown.bind(this);
        this.handlePointerMove = this.onPointerMove.bind(this);
        this.handlePointerUp = this.onPointerUp.bind(this);
        this.handleTouchStart = this.onTouchStart.bind(this);
        this.handleTouchEnd = this.onTouchEnd.bind(this);
        this.handleClickCapture = this.onClickCapture.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);
        this.handleVisibility = this.onVisibilityChange.bind(this);

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.supportsScrollEnd = 'onscrollend' in this.track;
        if (this.supportsScrollEnd) this.track.addEventListener('scrollend', this.handleScrollEnd);
        this.track.addEventListener('keydown', this.handleKeydown);
        this.track.addEventListener('pointerdown', this.handlePointerDown);
        this.track.addEventListener('pointermove', this.handlePointerMove);
        this.track.addEventListener('pointerup', this.handlePointerUp);
        this.track.addEventListener('pointercancel', this.handlePointerUp);
        this.track.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        this.track.addEventListener('touchend', this.handleTouchEnd, { passive: true });
        this.track.addEventListener('click', this.handleClickCapture, true);
        this.track.addEventListener('wheel', () => this.restartAutoplay(), { passive: true });

        if (this.previousButton) {
          this.previousButton.addEventListener('click', () => {
            this.move(-1, true);
            this.restartAutoplay();
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => {
            this.move(1, true);
            this.restartAutoplay();
          });
        }

        this.addEventListener('mouseenter', () => this.pauseAutoplay('hover'));
        this.addEventListener('mouseleave', () => this.resumeAutoplay('hover'));
        this.addEventListener('focusin', () => this.pauseAutoplay('focus'));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.resumeAutoplay('focus');
        });
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('visibilitychange', this.handleVisibility);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.onResize());
          this.resizeObserver.observe(this.track);
        } else {
          this.handleWindowResize = this.onResize.bind(this);
          window.addEventListener('resize', this.handleWindowResize, { passive: true });
        }

        requestAnimationFrame(() => {
          this.goToOriginal(0, false);
          this.updateActiveSlide();
          this.scheduleAutoplay();
        });
      }

      disconnectedCallback() {
        clearTimeout(this.scrollTimer);
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.resizeTimer);
        clearTimeout(this.centerTimer);
        clearTimeout(this.touchSnapTimer);
        cancelAnimationFrame(this.centerAnimationFrame);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.handleWindowResize) window.removeEventListener('resize', this.handleWindowResize);
        if (this.track) {
          this.track.removeEventListener('scroll', this.handleScroll);
          if (this.supportsScrollEnd) this.track.removeEventListener('scrollend', this.handleScrollEnd);
          this.track.removeEventListener('keydown', this.handleKeydown);
          this.track.removeEventListener('pointerdown', this.handlePointerDown);
          this.track.removeEventListener('pointermove', this.handlePointerMove);
          this.track.removeEventListener('pointerup', this.handlePointerUp);
          this.track.removeEventListener('pointercancel', this.handlePointerUp);
          this.track.removeEventListener('touchstart', this.handleTouchStart);
          this.track.removeEventListener('touchend', this.handleTouchEnd);
          this.track.removeEventListener('click', this.handleClickCapture, true);
        }
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      createLoopClones() {
        const firstClone = this.makeClone(this.originalSlides[0], 'end');
        const lastClone = this.makeClone(this.originalSlides[this.originalSlides.length - 1], 'start');
        this.track.insertBefore(lastClone, this.originalSlides[0]);
        this.track.appendChild(firstClone);
      }

      makeClone(slide, position) {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = position;
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('role', 'presentation');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      centerSlide(slide, smooth) {
        if (!slide) return;
        const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;

        cancelAnimationFrame(this.centerAnimationFrame);

        if (!smooth || this.reducedMotion.matches) {
          this.track.scrollLeft = left;
          return;
        }

        const start = this.track.scrollLeft;
        const distance = left - start;
        if (Math.abs(distance) <= 1) return;

        const duration = this.desktopMedia.matches ? 220 : 180;
        const startedAt = performance.now();

        const animate = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.track.scrollLeft = start + distance * eased;

          if (progress < 1) {
            this.centerAnimationFrame = requestAnimationFrame(animate);
          } else {
            this.centerAnimationFrame = null;
          }
        };

        this.centerAnimationFrame = requestAnimationFrame(animate);
      }

      distanceFromCenter(slide) {
        if (!slide) return Infinity;
        const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        return Math.abs(trackCenter - slideCenter);
      }

      centerNearestSlide(smooth) {
        this.updateActiveSlide();
        if (!this.activeSlide || this.distanceFromCenter(this.activeSlide) <= 1) return;

        this.isCentering = true;
        this.centerSlide(this.activeSlide, smooth);
        clearTimeout(this.centerTimer);
        this.centerTimer = setTimeout(() => {
          this.isCentering = false;
          this.onScrollSettled();
        }, 360);
      }

      goToOriginal(index, smooth) {
        const normalized = Math.max(0, Math.min(this.originalSlides.length - 1, index));
        this.logicalIndex = normalized;
        this.centerSlide(this.originalSlides[normalized], smooth);
      }

      move(direction, smooth) {
        this.updateActiveSlide();
        const current = this.activeSlide || this.originalSlides[this.logicalIndex];
        const currentPosition = this.slides.indexOf(current);
        const target = this.slides[currentPosition + direction];
        if (!target) return false;
        this.centerSlide(target, smooth);
        return true;
      }

      updateActiveSlide() {
        const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
        const inactiveScale = this.desktopMedia.matches ? 0.87 : 0.9;
        const cardLift = this.desktopMedia.matches ? 12 : 8;
        const mobilePeekShift = this.desktopMedia.matches ? 0 : 24;
        let nearest = this.slides[0];
        let nearestDistance = Infinity;

        this.slides.forEach((slide) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(trackCenter - slideCenter);
          const activity = 1 - Math.min(distance / Math.max(slide.offsetWidth, 1), 1);
          const scale = inactiveScale + (1 - inactiveScale) * activity;
          const translate = cardLift * (1 - activity);
          const opacity = 0.82 + 0.18 * activity;
          const descriptionOpacity = 0.72 + 0.04 * activity;
          const directionToCenter = slideCenter < trackCenter ? 1 : slideCenter > trackCenter ? -1 : 0;
          const shiftX = directionToCenter * mobilePeekShift * (1 - activity);

          slide.style.setProperty('--gb-card-scale', scale.toFixed(4));
          slide.style.setProperty('--gb-card-shift-x', shiftX.toFixed(2) + 'px');
          slide.style.setProperty('--gb-card-translate', translate.toFixed(2) + 'px');
          slide.style.setProperty('--gb-card-opacity', opacity.toFixed(4));
          slide.style.setProperty('--gb-description-opacity', descriptionOpacity.toFixed(4));

          if (distance < nearestDistance) {
            nearest = slide;
            nearestDistance = distance;
          }
        });

        this.slides.forEach((slide) => slide.classList.toggle('is-active', slide === nearest));
        this.activeSlide = nearest;
        this.logicalIndex = Number(nearest.dataset.index) || 0;

        this.originalSlides.forEach((slide, index) => {
          slide.setAttribute('aria-current', index === this.logicalIndex ? 'true' : 'false');
        });

        this.updateButtons();
      }

      updateButtons() {
        if (this.loopEnabled) {
          if (this.previousButton) this.previousButton.disabled = false;
          if (this.nextButton) this.nextButton.disabled = false;
          return;
        }

        if (this.previousButton) this.previousButton.disabled = this.logicalIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.logicalIndex === this.originalSlides.length - 1;
      }

      onScroll() {
        if (!this.scrollFrame) {
          this.scrollFrame = requestAnimationFrame(() => {
            this.updateActiveSlide();
            this.scrollFrame = null;
          });
        }

        if (!this.supportsScrollEnd) {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.onScrollSettled(), 65);
        }
      }

      onScrollSettled() {
        this.updateActiveSlide();
        if (this.touchSnapActive) return;
        if (this.dragging) return;
        if (!this.activeSlide) return;

        const centered = this.distanceFromCenter(this.activeSlide) <= 2;

        if (this.loopEnabled && this.activeSlide.dataset.clone && centered) {
          this.resetLoopPosition();
          return;
        }

        if (centered) {
          this.isCentering = false;
          clearTimeout(this.centerTimer);
          return;
        }

        if (!this.isCentering) this.centerNearestSlide(true);
      }

      resetLoopPosition() {
        const target = this.originalSlides[this.logicalIndex];
        this.classList.add('is-loop-jumping');
        this.isCentering = false;
        clearTimeout(this.centerTimer);
        this.centerSlide(target, false);
        this.activeSlide = target;
        this.updateActiveSlide();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.classList.remove('is-loop-jumping'));
        });
      }

      onKeydown(event) {
        if (event.target.closest('a, button, input, select, textarea')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1, true);
        this.restartAutoplay();
      }

      onPointerDown(event) {
        this.pauseAutoplay('pointer');
        cancelAnimationFrame(this.centerAnimationFrame);
        clearTimeout(this.centerTimer);
        clearTimeout(this.scrollTimer);
        clearTimeout(this.touchSnapTimer);
        this.track.classList.remove('is-touch-snapping');
        this.touchSnapActive = false;
        this.centerAnimationFrame = null;
        this.isCentering = false;
        if (event.pointerType !== 'mouse' || event.target.closest('a, button')) return;
        this.dragging = true;
        this.didDrag = false;
        this.dragStartX = event.clientX;
        this.dragStartScroll = this.track.scrollLeft;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        const distance = event.clientX - this.dragStartX;
        if (Math.abs(distance) > 4) this.didDrag = true;
        this.track.scrollLeft = this.dragStartScroll - distance;
        if (this.didDrag) event.preventDefault();
      }

      onPointerUp(event) {
        if (this.dragging) {
          this.dragging = false;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          this.updateActiveSlide();
          this.centerNearestSlide(true);
          setTimeout(() => {
            this.didDrag = false;
          }, 80);
        }

        if (event.pointerType !== 'touch') {
          setTimeout(() => this.resumeAutoplay('pointer'), 420);
        }
      }

      onTouchStart(event) {
        if (event.touches.length !== 1) return;
        this.updateActiveSlide();
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
        this.touchStartSlide = this.activeSlide;
      }

      onTouchEnd(event) {
        const touch = event.changedTouches[0];
        let targetSlide = null;
        let isHorizontalSwipe = false;

        if (touch && Number.isFinite(this.touchStartX) && this.touchStartSlide) {
          const deltaX = touch.clientX - this.touchStartX;
          const deltaY = touch.clientY - this.touchStartY;
          isHorizontalSwipe = Math.abs(deltaX) >= this.swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY) * 0.65;

          if (isHorizontalSwipe) {
            const direction = deltaX < 0 ? 1 : -1;
            const startPosition = this.slides.indexOf(this.touchStartSlide);
            targetSlide = this.slides[startPosition + direction] || null;
          }
        }

        this.touchStartX = null;
        this.touchStartY = null;
        this.touchStartSlide = null;

        if (event.target.closest('a, button') && !isHorizontalSwipe) {
          setTimeout(() => this.resumeAutoplay('pointer'), 420);
          return;
        }

        if (isHorizontalSwipe) {
          this.didTouchSwipe = true;
          setTimeout(() => {
            this.didTouchSwipe = false;
          }, 600);
        }

        this.snapTouchRelease(targetSlide);
        setTimeout(() => this.resumeAutoplay('pointer'), 420);
      }

      snapTouchRelease(targetSlide) {
        cancelAnimationFrame(this.centerAnimationFrame);
        clearTimeout(this.centerTimer);
        clearTimeout(this.scrollTimer);
        clearTimeout(this.touchSnapTimer);

        const lockedLeft = this.track.scrollLeft;
        this.touchSnapActive = true;
        this.isCentering = false;
        this.track.classList.add('is-touch-snapping');
        this.track.scrollLeft = lockedLeft;
        this.track.getBoundingClientRect();

        requestAnimationFrame(() => {
          this.updateActiveSlide();
          if (targetSlide) {
            this.isCentering = true;
            this.centerSlide(targetSlide, true);
            clearTimeout(this.centerTimer);
            this.centerTimer = setTimeout(() => {
              this.isCentering = false;
              this.onScrollSettled();
            }, 360);
          } else {
            this.centerNearestSlide(true);
          }
        });

        this.touchSnapTimer = setTimeout(() => {
          this.track.classList.remove('is-touch-snapping');
          this.touchSnapActive = false;
          this.updateActiveSlide();
          this.onScrollSettled();
        }, 230);
      }

      onClickCapture(event) {
        if (!this.didDrag && !this.didTouchSwipe) return;
        event.preventDefault();
        event.stopPropagation();
        this.didTouchSwipe = false;
      }

      onBlockSelect(event) {
        const blockId = event.detail && event.detail.blockId;
        if (!blockId) return;
        const slide = this.originalSlides.find((item) => item.dataset.blockId === blockId);
        if (!slide) return;
        this.pauseAutoplay('editor');
        this.goToOriginal(Number(slide.dataset.index), true);
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          if (!this.dragging) this.goToOriginal(this.logicalIndex, false);
        }, 100);
      }

      onVisibilityChange() {
        if (document.hidden) this.pauseAutoplay('visibility');
        else this.resumeAutoplay('visibility');
      }

      autoplayAllowed() {
        if (this.reducedMotion.matches || this.pauseReasons.size || document.hidden) return false;
        return this.desktopMedia.matches ? this.autoplayDesktop : this.autoplayMobile;
      }

      scheduleAutoplay() {
        clearTimeout(this.autoplayTimer);
        if (!this.autoplayAllowed() || this.originalSlides.length < 2) return;

        this.autoplayTimer = setTimeout(() => {
          const moved = this.move(1, true);
          if (moved) this.scheduleAutoplay();
        }, this.autoplaySpeed);
      }

      restartAutoplay() {
        clearTimeout(this.autoplayTimer);
        this.scheduleAutoplay();
      }

      pauseAutoplay(reason) {
        this.pauseReasons.add(reason);
        clearTimeout(this.autoplayTimer);
      }

      resumeAutoplay(reason) {
        this.pauseReasons.delete(reason);
        this.scheduleAutoplay();
      }
    }

    customElements.define('gb-group-carousel', GbGroupCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gb-review-carousel')) {
    customElements.define(
      'gb-review-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.track = this.querySelector('[data-review-track]');
          this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
          this.previousButton = this.querySelector('[data-review-previous]');
          this.nextButton = this.querySelector('[data-review-next]');
          this.status = this.querySelector('[data-review-status]');
          this.loop = this.dataset.loop === 'true';
          this.autoplay = this.dataset.autoplay === 'true';
          this.autoplaySpeed = Math.max(3000, Number(this.dataset.autoplaySpeed) || 7000);
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.index = -1;
          this.scrollFrame = null;
          this.autoplayTimer = null;
          this.resizeTimer = null;
          this.dragging = false;
          this.didDrag = false;

          if (!this.track || this.slides.length === 0) return;

          this.onScrollBound = this.onScroll.bind(this);
          this.onKeydownBound = this.onKeydown.bind(this);
          this.onPointerDownBound = this.onPointerDown.bind(this);
          this.onPointerMoveBound = this.onPointerMove.bind(this);
          this.onPointerUpBound = this.onPointerUp.bind(this);
          this.onClickBound = this.onClick.bind(this);
          this.onBlockSelectBound = this.onBlockSelect.bind(this);
          this.onVisibilityBound = this.onVisibility.bind(this);

          this.track.addEventListener('scroll', this.onScrollBound, { passive: true });
          this.track.addEventListener('keydown', this.onKeydownBound);
          this.track.addEventListener('pointerdown', this.onPointerDownBound);
          this.track.addEventListener('pointermove', this.onPointerMoveBound);
          this.track.addEventListener('pointerup', this.onPointerUpBound);
          this.track.addEventListener('pointercancel', this.onPointerUpBound);
          this.track.addEventListener('click', this.onClickBound, true);

          if (this.previousButton) this.previousButton.addEventListener('click', () => this.move(-1, true));
          if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1, true));

          this.addEventListener('mouseenter', () => this.pause());
          this.addEventListener('mouseleave', () => this.schedule());
          this.addEventListener('focusin', () => this.pause());
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.schedule();
          });

          document.addEventListener('shopify:block:select', this.onBlockSelectBound);
          document.addEventListener('visibilitychange', this.onVisibilityBound);

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.onResize());
            this.resizeObserver.observe(this.track);
          }

          requestAnimationFrame(() => {
            this.goTo(0, false, false);
            this.update(0, false);
            this.schedule();
          });
        }

        disconnectedCallback() {
          this.pause();
          clearTimeout(this.resizeTimer);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.track) {
            this.track.removeEventListener('scroll', this.onScrollBound);
            this.track.removeEventListener('keydown', this.onKeydownBound);
            this.track.removeEventListener('pointerdown', this.onPointerDownBound);
            this.track.removeEventListener('pointermove', this.onPointerMoveBound);
            this.track.removeEventListener('pointerup', this.onPointerUpBound);
            this.track.removeEventListener('pointercancel', this.onPointerUpBound);
            this.track.removeEventListener('click', this.onClickBound, true);
          }
          document.removeEventListener('shopify:block:select', this.onBlockSelectBound);
          document.removeEventListener('visibilitychange', this.onVisibilityBound);
        }

        slideLeft(slide) {
          return slide.offsetLeft - this.slides[0].offsetLeft;
        }

        goTo(index, smooth, announce = true) {
          if (!this.slides.length) return;
          let nextIndex = index;
          if (this.loop) nextIndex = (index + this.slides.length) % this.slides.length;
          else nextIndex = Math.max(0, Math.min(this.slides.length - 1, index));
          const behavior = smooth && !this.reducedMotion.matches ? 'smooth' : 'auto';
          this.track.scrollTo({ left: this.slideLeft(this.slides[nextIndex]), behavior });
          this.update(nextIndex, announce);
        }

        move(direction, announce) {
          this.goTo(this.index + direction, true, announce);
          this.restart();
        }

        update(index, announce = true) {
          if (index === this.index && this.slides[index].classList.contains('is-active')) return;
          this.index = index;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-current', active ? 'true' : 'false');
          });
          this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
          if (this.previousButton) this.previousButton.disabled = !this.loop && index === 0;
          if (this.nextButton) this.nextButton.disabled = !this.loop && index === this.slides.length - 1;
          if (announce && this.status) this.status.textContent = `${index + 1} / ${this.slides.length}`;
        }

        nearestIndex() {
          const trackLeft = this.track.scrollLeft;
          let nearest = 0;
          let distance = Infinity;
          this.slides.forEach((slide, index) => {
            const currentDistance = Math.abs(this.slideLeft(slide) - trackLeft);
            if (currentDistance < distance) {
              distance = currentDistance;
              nearest = index;
            }
          });
          return nearest;
        }

        onScroll() {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.update(this.nearestIndex(), false);
            this.scrollFrame = null;
          });
        }

        onKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1, true);
        }

        onPointerDown(event) {
          this.pause();
          if (event.pointerType !== 'mouse' || event.target.closest('a, button')) return;
          this.dragging = true;
          this.didDrag = false;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 4) this.didDrag = true;
          this.track.scrollLeft = this.startScroll - distance;
          if (this.didDrag) event.preventDefault();
        }

        onPointerUp(event) {
          if (!this.dragging) {
            this.schedule();
            return;
          }
          this.dragging = false;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          this.goTo(this.nearestIndex(), true, true);
          setTimeout(() => {
            this.didDrag = false;
          }, 80);
          this.schedule();
        }

        onClick(event) {
          if (!this.didDrag) return;
          event.preventDefault();
          event.stopPropagation();
        }

        onBlockSelect(event) {
          const blockId = event.detail && event.detail.blockId;
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === blockId);
          if (index < 0) return;
          this.pause();
          this.goTo(index, true, false);
        }

        onResize() {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.goTo(this.index, false, false), 100);
        }

        onVisibility() {
          if (document.hidden) this.pause();
          else this.schedule();
        }

        pause() {
          clearTimeout(this.autoplayTimer);
        }

        schedule() {
          this.pause();
          if (!this.autoplay || this.reducedMotion.matches || document.hidden || this.slides.length < 2) return;
          this.autoplayTimer = setTimeout(() => {
            if (!this.loop && this.index >= this.slides.length - 1) {
              this.pause();
              return;
            }
            this.goTo(this.index + 1, true, false);
            this.schedule();
          }, this.autoplaySpeed);
        }

        restart() {
          this.pause();
          this.schedule();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gurbakir-image-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGbImageAccordion(root) {
      var scope = root || document;
      var items = scope.querySelectorAll('.gb-image-accordion__item');

      items.forEach(function (item) {
        if (item.dataset.gbAccordionReady === 'true') return;

        var summary = item.querySelector('.gb-image-accordion__summary');
        var shell = item.querySelector('.gb-image-accordion__answer-shell');
        var answer = item.querySelector('.gb-image-accordion__answer');

        if (!summary || !shell || !answer) return;

        item.dataset.gbAccordionReady = 'true';

        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (item.dataset.gbAnimating === 'true') return;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            item.open = !item.open;
            return;
          }

          item.dataset.gbAnimating = 'true';

          if (!item.open) {
            item.open = true;

            var targetHeight = shell.scrollHeight;

            var shellAnimation = shell.animate(
              [
                { height: '0px', opacity: 0 },
                { height: targetHeight + 'px', opacity: 1 }
              ],
              {
                duration: 340,
                easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
              }
            );

            answer.animate(
              [
                { opacity: 0, transform: 'translateY(-7px)' },
                { opacity: 0.78, transform: 'translateY(0)' }
              ],
              {
                duration: 280,
                easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
              }
            );

            shellAnimation.onfinish = function () {
              item.dataset.gbAnimating = 'false';
            };
          } else {
            var startHeight = shell.getBoundingClientRect().height;

            var closeAnimation = shell.animate(
              [
                { height: startHeight + 'px' },
                { height: '0px' }
              ],
              {
                duration: 220,
                easing: 'cubic-bezier(0.4, 0, 1, 1)',
                fill: 'forwards'
              }
            );

            closeAnimation.onfinish = function () {
              item.open = false;
              closeAnimation.cancel();
              item.dataset.gbAnimating = 'false';
            };
          }
        });
      });
    }

    initGbImageAccordion(document);

    document.addEventListener('shopify:section:load', function (event) {
      initGbImageAccordion(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
